<template>
    <div>
        <NavbarStyleTwo />
        <TakeYourBusiness />
        <Partner />
        <WhyChooseUs />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import TakeYourBusiness from '../About/TakeYourBusiness';
import Partner from '../Common/Partner';
import WhyChooseUs from '../Common/WhyChooseUs';
import Footer from '../Layouts/Footer';

export default {
    setup() {
        useHead({
            title: 'Über uns - Benovium | Webentwicklung Wien',
            meta: [
                { name: 'description', content: 'Lernen Sie Benovium kennen - Ihr Partner für professionelle Webentwicklung in Wien. Persönliche Betreuung, transparente Kommunikation, messbare Ergebnisse.' },
                { property: 'og:title', content: 'Über uns - Benovium' },
                { property: 'og:description', content: 'Ihr Partner für professionelle Webentwicklung in Wien.' },
                { property: 'og:url', content: 'https://benovium.com/about' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/about' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        TakeYourBusiness,
        Partner,
        WhyChooseUs,
        Footer,
    }
};
</script>
